export const PersonalBundleStyles = {
  container: {
    width: '100%',
    height: '100%',
    gap: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media(max-width: 600px)': {
      marginLeft: '0px',
    },
  },

  field: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
};
